import { PersonPersonAttributes } from "integration/generated/transactions/data-contracts";
import { XChildrenDetails } from "../types/Person";

export type ChildBirthDateFormat = "DD-MM-YYYY" | "YYYY-MM-DD";

export const initializeXChildrenDetails = (
    children:number, 
    x_childrenDetailsDB:XChildrenDetails[],
    dateOutputFormat?:ChildBirthDateFormat
): XChildrenDetails[] => {
    
    if(x_childrenDetailsDB.length === children) {
        return [...x_childrenDetailsDB].map(
            child=>{
                return {
                    ...child, 
                    childDateOfBirth:formatChildBirthDate(child?.childDateOfBirth??'', dateOutputFormat)
                }
            }
        );
    }
    const tempXChildrenDetails:XChildrenDetails[] = [];
    for (let i = 0; i < children; i++) {
        const tempXChild = x_childrenDetailsDB?.at(i);
        tempXChildrenDetails.push(
            tempXChild ? {
                childDateOfBirth:tempXChild?.childDateOfBirth 
                                    ? 
                                    formatChildBirthDate(tempXChild?.childDateOfBirth??'', dateOutputFormat) 
                                    : null,
                childFirstName:tempXChild?.childFirstName??null,
                childLastName:tempXChild?.childDateOfBirth??null,
                userRelId:tempXChild?.userRelId??null,
            }: {} as XChildrenDetails
        )
    }
    return tempXChildrenDetails;
}

export const getChildrenAttrs = (children: XChildrenDetails[]): PersonPersonAttributes[] => {
    return children
        .filter(
            child =>
                child.childFirstName?.trim() || child.childDateOfBirth?.trim()
        )
        .map((child, i) => ({
            pProfileAttrKey: `childDetails_${i + 1}`,
            pProfileAttrValue: `${child.childFirstName ?? ''}###${formatChildBirthDate(child.childDateOfBirth, "YYYY-MM-DD") ?? ''}`
        }));
};

export const formatChildBirthDate = (
	date: Date | string | null,
	outputFormat: ChildBirthDateFormat = "DD-MM-YYYY"
): string => {
	if (!date) return "";

	const format = (y: number, m: number, d: number) => {
		const dd = String(d).padStart(2, "0");
		const mm = String(m).padStart(2, "0");
		const yyyy = String(y);

		return outputFormat === "DD-MM-YYYY"
			? `${dd}-${mm}-${yyyy}`
			: `${yyyy}-${mm}-${dd}`;
	};

	// ✅ Date object
	if (date instanceof Date) {
		if (isNaN(date.getTime())) return "";
		return format(date.getFullYear(), date.getMonth() + 1, date.getDate());
	}

	// ✅ String input
	if (typeof date === "string") {
		const parts = date.split("-").map(x => x.trim());

		// Case: DD-MM-YY or DD-MM-YYYY
		if (parts.length === 3 && parts[0].length <= 2 && parts[1].length === 2) {
			const [day, month, yearRaw] = parts;
			const year = yearRaw.length === 2 ? `20${yearRaw}` : yearRaw;
			return format(Number(year), Number(month), Number(day));
		}

		// Case: YYYY-MM-DD
		if (parts.length === 3 && parts[0].length === 4) {
			const [year, month, day] = parts;
			return format(Number(year), Number(month), Number(day));
		}

		// Fallback: try parsing
		const parsed = new Date(date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
		if (!isNaN(parsed.getTime())) {
			return format(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
		}

		return "";
	}

	return "";
};
